/* ════ BUILD HEADER ════════════════════════════════════════ */
import { state } from '../state.js';
import { $ } from '../dom.js';
import { MO } from '../config.js';
import { ddiff, addD, isoWk, isWE, isMon } from '../utils/date.js';
import { specialDay, headerExtras } from '../seasonal.js';

export function buildHeader() {
  const todayMid = new Date(); todayMid.setHours(0, 0, 0, 0);
  const hdr = $('tl-hdr'), ti = ddiff(state.viewStart, todayMid);
  const days = Array.from({ length: state.viewDays }, (_, i) => addD(state.viewStart, i));
  const months = [], weeks = []; let cm = null, cs = 0, cw = null, cws = 0;
  days.forEach(d => {
    const m = d.getMonth(), w = isoWk(d);
    if (m !== cm) { if (cm !== null) months.push({ m: cm, s: cs }); cm = m; cs = 1; } else cs++;
    if (w !== cw) { if (cw !== null) weeks.push({ w: cw, s: cws }); cw = w; cws = 1; } else cws++;
  });
  months.push({ m: cm, s: cs }); weeks.push({ w: cw, s: cws });
  const DAY_W = state.DAY_W;
  hdr.innerHTML = `
    <div class="tl-months">${months.map(({ m, s }) => `<div class="mo-l" style="width:${s * DAY_W}px">${MO[m]}</div>`).join('')}</div>
    <div class="tl-weeks">${weeks.map(({ w, s }) => `<div class="wk-l" style="width:${s * DAY_W}px">W${w}</div>`).join('')}</div>
    <div class="tl-days">${days.map((d, i) => dayCell(d, i === ti, DAY_W)).join('')}</div>${headerExtras()}`;
}

// A day number; special days (Halloween, Christmas…) also get their emoji.
// Narrow columns show just the emoji (the date is in the tooltip).
function dayCell(d, isToday, DAY_W) {
  const sd = specialDay(d);
  const cls = `dy-c${isWE(d) ? ' we' : ''}${isMon(d) ? ' mon' : ''}${isToday ? ' tod' : ''}`
    + (sd ? ` sd sd-${sd.k}${sd.fx ? ' sd-fx' : ''}${DAY_W < 30 ? ' narrow' : ''}` : '');
  const title = d.toDateString() + (sd ? ` · ${sd.name}` : '');
  const inner = sd ? `<span class="dy-num">${d.getDate()}</span><span class="dy-deco">${sd.e}</span>` : d.getDate();
  return `<div class="${cls}" style="width:${DAY_W}px" title="${title}">${inner}</div>`;
}
